import {
  Link,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';

import {
  BarChart3,
  FileText,
} from 'lucide-react';

import LeadDashboardPage from './LeadDashboardPage';
import { FormsPlatform } from './FormsPlatform';

const TABS = [
  {
    path: 'dashboard',
    label: 'Dashboard',
    icon: BarChart3,
  },
  {
    path: '',
    label: 'Forms',
    icon: FileText,
  },
] as const;

export default function LeadModule() {
  const location = useLocation();

  const isTabActive = (path: string) => {
    switch (path) {
      case 'dashboard':
        return location.pathname === '/forms/dashboard';

      case '':
        return (
          location.pathname === '/forms' ||
          (
            location.pathname.startsWith('/forms/') &&
            location.pathname !== '/forms/dashboard'
          )
        );

      default:
        return false;
    }
  };

  return (
    <div className="min-h-screen p-6 pt-10 md:p-8 lg:p-10">
      <header className="mt-5 mb-8">
        <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-800">
          <FileText
            className="text-strivre-burgundy"
            size={24}
          />

          Forms
        </h1>

        <p className="mt-1 text-left text-sm text-slate-500">
          Create forms, collect submissions, and monitor engagement across your organization.
        </p>
      </header>

      <div className="mb-6">
        <div className="flex flex-wrap gap-1 rounded-2xl border border-strivre-lightnavy bg-strivre-softgrey p-1 shadow-inner md:p-1.5">
          {TABS.map((tab) => {
            const target =
              tab.path === ''
                ? '/forms'
                : `/forms/${tab.path}`;

            return (
              <Link
                key={tab.path}
                to={target}
                className={`flex flex-1 items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-xs font-bold transition-all md:text-sm lg:flex-none ${
                  isTabActive(tab.path)
                    ? 'bg-strivre-burgundy text-white shadow-sm'
                    : 'text-slate-500 hover:text-strivre-burgundy'
                }`}
              >
                <tab.icon size={18} />
                {tab.label}
              </Link>
            );
          })}
        </div>
      </div>

      <Routes>
        <Route
          path="dashboard"
          element={<LeadDashboardPage />}
        />

        <Route
          path="*"
          element={<FormsPlatform />}
        />
      </Routes>
    </div>
  );
}